import React from 'react';

import Toggle from '@atlaskit/toggle';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { usePremiumFeatureHighlight } from './usePremiumFeatureHighlight.ts';

export enum PillTypeForToggleAnalytics {
	HAS_PAYMENT = 'hasPayment',
	NO_PAYMENT = 'noPayment',
	END_USER = 'endUser',
}

export type PremiumFeatureHighlightToggleProps = {
	id?: string;
	source: 'premTrialActionComponent' | 'premTrialOnboardingModal';
	pillType?: PillTypeForToggleAnalytics;
	isPTORTEnabled?: boolean;
};

export const PremiumFeatureHighlightToggle = ({
	id,
	source,
	pillType,
	isPTORTEnabled = false,
}: PremiumFeatureHighlightToggleProps) => {
	const [{ isEnabled: isChecked }, { update }] = usePremiumFeatureHighlight();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleChange = async () => {
		createAnalyticsEvent({
			type: 'sendUIEvent',
			data: {
				action: 'clicked',
				actionSubject: 'toggle',
				actionSubjectId: 'premiumTrialOnboardingToggle',
				attributes: {
					prevState: isChecked,
					currentState: !isChecked,
					pillType: pillType || null,
					isPTORTEnabled,
				},
				source,
			},
		}).fire();
		await update();
	};

	return <Toggle id={id} isChecked={isChecked} onChange={handleChange} />;
};
